<!-- メニュー一覧 -->
<template>
  <div class="menu-content">
    <p class="title">引き換えたい商品・メニューを<br />選んで下さい</p>

    <div class="menu-index">
      <!-- メニュー一覧をfor文で表示 -->
      <div v-for="(menu, index) in menus" :key="index" class="item_content">
        <SMenuCard
          :menu="menu"
          :index="index"
          :radio="radio"
          @parent="changedRadioValue"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheSheetMenuIndex",
  props: {
    menus: {
      type: Array,
    },
    radio: {
      type: String,
    },
  },
  methods: {
    changedRadioValue(value) {
      this.$emit("grandParent", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-content {
  position: relative;
  top: 180px;

  .title {
    text-align: center;
    line-height: 1.6rem;
    height: 90px;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
    border-bottom: 1px solid #e0e0e0;
  }
  .menu-index {
    margin-bottom: 100px;
    overflow-y: scroll;
  }
  .item_content {
    padding: 5px;
    height: 80px;
    border-bottom: 1px solid #e0e0e0;
  }
  .item_content:last-child {
    margin-bottom: 100px;
  }
}
</style>
